import Api, { baseURL, requestOptionsGET, requestOptionsPUTWithBody } from "../api";
import newFetch from "../utils/newFetch";

const state = {
  stops: [],
  manegementStops: [],
  deliveries: [],
  manegementDeliveries: [],
  nfes: [],
  manegementNfes: [],
  callNumber: Number,
  paginate: {
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0,
  },
};

const getters = {
  getStops: (state) => state.stops,
  getManegementStops: (state) => state.manegementStops,
  getDeliveries: (state) => state.deliveries,
  getManegementDeliveries: (state) => state.manegementDeliveries,
  getPaginate: ({ paginate }) => {
    return `&PageSize=${paginate.pageSize}&PageNumber=${paginate.pageNumber}`;
  },
};

const mutations = {
  setStops(state, payload) {
    state.stops = payload;
  },
  setManegementStops(state, payload) {
    state.manegementStops = payload;
  },
  setDeliveries(state, payload) {
    state.deliveries = payload;
  },
  setManegementDeliveries(state, payload) {
    state.manegementDeliveries = payload;
  },
  setNfes(state, payload) {
    state.nfes = payload;
  },
  setManegementNfes(state, payload) {
    state.manegementNfes = payload;
  },
  setItemPerPage(state, payload) {
    state.paginate.pageSize = payload;
  },
  setPageNumber(state, payload) {
    state.paginate.pageNumber = payload;
  },
  setTotalPages(state, payload) {
    state.paginate.totalPages = payload;
  },
  setTotalRecords(state, payload) {
    state.paginate.totalRecords = payload;
  },
  setCallNumber(state, payload) {
    state.callNumber = payload;
  },
};

const actions = {
  fetchStopsByID(context) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
        Api.getStopByStatus +
        "?statusId=8&statusId=15" +
        context.getters.getPaginate,
        requestOptionsGET(localStorage.getItem("accessToken"))
      )
        .then(({ data, totalPages, totalRecords }) => {
          context.commit("setStops", data);

          context.commit("setTotalPages", totalPages);
          context.commit("setTotalRecords", totalRecords);

          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  fetchDeliveriesByID(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
        Api.getDeliveriesDetails +
        id +
        "?statusId=8&statusId=15",
        requestOptionsGET(localStorage.getItem("accessToken"))
      )
        .then((data) => {
          context.commit("setDeliveries", data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  fetchNfesByID(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getNfe + id + "?statusId=8&statusId=15",
        requestOptionsGET(localStorage.getItem("accessToken"))
      )
        .then((data) => {
          context.commit("setNfes", data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  toBeReturned(_, params = {}) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.toBeReturned,
        requestOptionsPUTWithBody(localStorage.getItem("accessToken"), params)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
